import { Injectable } from '@angular/core';
import { DataAccessService } from '../../shared/services/dataaccess.service';
export class forgotPassWord
{
  StudeMailId :string;
  MobileNo:string;
  PreExamOtpId:Number;
  MoblieOTP: string;
  confirmPassword:string;
  Password:string;
  Password1:string
}
@Injectable({
  providedIn: 'root'
})
export class ForgetPasswordPageService {
  constructor(private dataService: DataAccessService) { }
  getGridColumnsData() {
    return forgotPassWord[0];
  } 
   public VerifyMobOTP(MobileNo,mobOTP){debugger
    this.dataService.setControllerName = '/PortalStudentLogIn/';
    this.dataService.setMethodName = 'GetVerifyMobileOtp?MobileNo='+MobileNo+'&MoblieOTP='+mobOTP+''; 
    return this.dataService.getAll<forgotPassWord[]>()
  }
  
  public VerifyDuplicateMob(MobileNo){debugger
    this.dataService.setControllerName = '/PortalStudentLogIn/';
    this.dataService.setMethodName = 'GetMobileExist?MobileNo='+MobileNo; 
    return this.dataService.getAll<forgotPassWord[]>()
  }
  public GenerateMobOTP(UserName,MobileNo){debugger
    this.dataService.setControllerName = '/PortalStudentLogIn/';
    this.dataService.setMethodName = 'GetGenerateForgetPassOTP?UserName='+ UserName +'&MobileNo='+ MobileNo; 
    return this.dataService.getAll<forgotPassWord[]>()
  }
  public update(data) {debugger
    this.dataService.setControllerName = '/PortalStudentLogIn/';
    this.dataService.setMethodName = 'PostUpdateForgetPassword?EmailID='+ data.StudeMailId +'&MobileNo='+ data.MobileNo +'&NewPassword='+ data.Password1; 
    return this.dataService.add<forgotPassWord[]>(data) 
  }
  
}
